import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchPlacements,
  fetchAllPlacements,
  addNewPlacement,
  updatePlacement,
} from "./placementsApi";
// import {
//   getPlacementsStart,
//   getPlacementsSuccess,
//   getPlacementsFailure,
// } from "./placementsSlice";

import {
  getAllPlacementsStart,
  getAllPlacementsSuccess,
  getAllPlacementsFailure,
  getPlacementByUiidStart,
  getPlacementByUiidSuccess,
  gePlacementByUiidFailure,
  //////////////////////////
  addNewPlacementStart,
  addNewPlacementSuccess,
  addNewPlacementFailure,
  addCurrentPlacement,
} from "./placementsSlice";
import { showToast } from "../../../components";

function* fetchAllPlacementsSaga(action) {
  try {
    const placements = yield call(fetchAllPlacements, action.payload);
    yield put(getAllPlacementsSuccess(placements.data));
  } catch (error) {
    console.error("Placements fetch error:", error);
    yield put(getAllPlacementsFailure(error.message));
  }
}

function* fetchPlacementsSaga(action) {
  try {
    const placements = yield call(fetchPlacements, action.payload);
    yield put(getPlacementByUiidSuccess(placements.data));
  } catch (error) {
    console.error("Placements fetch error:", error);
    yield put(gePlacementByUiidFailure(error.message));
  }
}

function* addNewPlacementSaga(action) {
  try {
    const { payload, navigate, uiid, tPath,patchId,onSuccess,rsd,rsn  } = action.payload;
    let response;
    if (uiid) {
      response = yield call(updatePlacement, uiid,patchId, payload);
    } else {
      response = yield call(addNewPlacement, tPath,patchId, payload);
    }
    if (response.success) {
      if(onSuccess){
        onSuccess(response)
      }
      showToast(`${rsn} updated`, "success", 5000);
      yield put(addNewPlacementSuccess(response.data));
      if (uiid) {
        yield put(addCurrentPlacement({  [rsn]:{...rsd},data:response?.data?.data}));
      } else {
        yield put(
          addCurrentPlacement({
             [rsn]:{...rsd},
            uiid: response?.data?.data?.placementId,
            data:response?.data?.data
          })
        );
      }
      //navigate("/placements");
    } else {
      showToast(response.error || 'Something went wrong!', "error", 3000);
      yield put(addNewPlacementFailure(response.error));
    }
  } catch (error) {
    console.error("Add New Placement Error:", error);
    yield put(addNewPlacementFailure(error.message));
  }
}

export function* watchFetchPlacements() {
  yield takeLatest(getAllPlacementsStart.type, fetchAllPlacementsSaga);
  yield takeLatest(getPlacementByUiidStart.type, fetchPlacementsSaga);
  yield takeLatest(addNewPlacementStart.type, addNewPlacementSaga);
}

// export function* watchFetchPlacements() {
//   yield takeLatest(getPlacementByUiidStart.type, fetchPlacementsSaga);
// }
